import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-bootstrap';

export const PaginationInfo = ({ currentPage, pageSize, listCount }) => {
    const startIndex = currentPage * pageSize + 1;
    const endIndex = Math.min((currentPage + 1) * pageSize, listCount);
  
    return (
      <div className="pagination-info d-flex align-items-center">
        <span className="page me-2">
          Showing <strong>{startIndex}</strong> to <strong>{endIndex}</strong> of <strong>{listCount}</strong> records
        </span>
      </div>
    );
  };
  PaginationInfo.propTypes = {
    currentPage: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    listCount: PropTypes.number.isRequired,
  };
  
  PaginationInfo.defaultProps = {
    currentPage: 0,
    pageSize: 10,
    listCount: 0,
  };

  export const DataNotFound = () => {
    return(
      <div className="NodataAvailableVMTDD NodataAvailable">Something Went Wrong</div>
    );
  };


  export const checkColumn = (column) => {
    const getData = column.map((item) => { return ({ name: item.Header, liftHeader: item.hasOwnProperty('columns') });});
    return getData;
  };

export const getTooltipOverlay = (column) => {
  if (!column.isTooltip) return <span />;
  if (column.id === "select" && column.showTooltip) return <span />;
  return (
    <Tooltip className="tooltipHeader tableToolTipBody">
      {column.isTooltip}
    </Tooltip>
  );
};


